import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { get } from 'lodash'
import {
  ALL_EXCEPT_CYRILLIC_REGEXP,
  TRANSFORM_VALID_TEST_NAME,
} from '../../../constants/validations'
import { FormInputFieldEntity } from '../../../types'
import { StyledTextField } from './StyledComponents/StyledFormControlledTextField'

const longErrorTypesArray = ['additionalDetails', 'numberAndLatinOnly', 'numberAndLatinicaField']

export const FormControlledTextField: React.FC<FormInputFieldEntity> = ({
  type,
  name,
  label,
  placeholder,
  defaultValue = '',
  onInputChange,
  helpText = '',
  disabled,
  externalError,
  endAdornmentIcon,
  ...rest
}) => {
  const { t } = useTranslation()
  const { control, errors, watch } = useFormContext()
  const error = externalError ? externalError : errors ? get(errors, name) : null
  const isLongError = longErrorTypesArray.includes(errors[name]?.type)
  const fieldValue = watch(name)

  return (
    <Controller
      render={({ onChange, ...other }) => (
        <StyledTextField
          {...other}
          label={label}
          value={fieldValue || ''}
          type={!!type ? type : 'text'}
          placeholder={placeholder ?? ''}
          error={!!externalError || !!error}
          onKeyDown={(event) => {
            if (!ALL_EXCEPT_CYRILLIC_REGEXP.test(event.key)) {
              event.preventDefault()
            }
          }}
          onChange={(e) => {
            onChange(e)
            if (onInputChange) {
              onInputChange(e)
            }
          }}
          helperText={
            externalError || error ? t(externalError?.message || error.message) : helpText
          }
          variant="standard"
          margin="normal"
          InputProps={{
            margin: 'none',
            endAdornment: endAdornmentIcon && <Box mr={1}>{endAdornmentIcon}</Box>,
          }}
          fullWidth={true}
          data-test={`autotest-${name.replace(TRANSFORM_VALID_TEST_NAME, '$1$2')}`}
          disabled={disabled}
          isError={!!externalError || !!error}
          isLongError={isLongError}
          labelLength={label?.toString()?.length}
          {...rest}
        />
      )}
      id={name}
      control={control}
      name={name}
      defaultValue={defaultValue}
    />
  )
}
